export default __webpack_public_path__ + "static/media/catball.18df2ffb.png";